var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  fillRule: "nonzero",
  d: "M9.5 2C6.48 2 4 4.283 4 7.538c0 1.162.283 1.97.806 2.866l4.324 7.384c.074.131.216.212.37.212s.296-.08.37-.212l4.324-7.384C14.717 9.509 15 8.7 15 7.538 15 4.283 12.519 2 9.5 2m0 2.872c1.402 0 2.538 1.102 2.538 2.461 0 1.36-1.136 2.462-2.538 2.462S6.96 8.693 6.96 7.333 8.098 4.872 9.5 4.872"
})));
export default SvgIconLocation;